import { loadManifest } from '@angular-architects/module-federation';
import { environment } from './environments/environment';

loadManifest(environment.federation_Url).catch((err) => {console.log('Error loading remote entries', err)})
  .then(() => import('./bootstrap'));